import React, { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { companyPlan as companyPlanEnum } from '../../../constants/enum';
import AccountManagementDialog from './AccountManagementDialog';

type Props = {
  open: boolean;
  onClose: () => void;
  companyPlan?: number;
};

const OcrLimitDialog = ({ open, onClose, companyPlan }: Props): ReactElement => {
  const navigate = useNavigate();
  const isFreePlan = companyPlan === companyPlanEnum.free;

  return (
    <AccountManagementDialog
      open={open}
      onClose={onClose}
      onContact={(): void => {
        onClose();
        navigate(
          isFreePlan
            ? '/contact?category=plan&type=plan_change'
            : '/contact?category=plan&type=ocr_credit',
        );
      }}
      title={isFreePlan ? 'OCR実行回数の上限に達しました' : 'OCRクレジット残高が不足しています'}
      descriptionLines={
        isFreePlan
          ? [
              '今月のOCR実行回数が利用上限に達しました。',
              'フリープランでは追加のOCR実行ができません。スタンダードプラン以上へのアップグレードをご検討ください。',
            ]
          : [
              '今月のOCR実行回数が利用上限に達しました。',
              'OCRを継続するにはOCRクレジットの追加購入が必要です。ご希望の購入金額をお問い合わせフォームよりお知らせください。',
            ]
      }
      contactButtonText="お問い合わせ"
      hideCancelButton={true}
    />
  );
};

export default OcrLimitDialog;
